// extracted by mini-css-extract-plugin
module.exports =  {"tab-content":"TEpHpiF","tabContent":"TEpHpiF","recommended":"FL6O5_N","package-content":"zxTHQ6r","packageContent":"zxTHQ6r"};